import { ButtonMain } from '@quero-delivery/quero-components-web';
import { useQueryClient } from '@tanstack/react-query';
import { Modal } from '@querodelivery/uni-react';
import styles from './styles.module.scss';
import { useSetDeliverymenOffline } from '../../api/put-set-offline';
import { GET_INFOS_QUERY_KEY } from '@/_constants/keys';
import { MODAL_WIDTH } from '@/_constants/styles';

export interface ModalSetStatusOfflineDeliverymansProps {
  open: boolean;
  onClose: () => void;
  deliverymenIds: string[];
  fnCallback?: () => void;
}

function ModalSetStatusOfflineDeliveryman({
  open,
  onClose,
  deliverymenIds,
  fnCallback,
}: ModalSetStatusOfflineDeliverymansProps) {
  const { mutate: setStatusOffline, isLoading } = useSetDeliverymenOffline();

  const queryClient = useQueryClient();

  const handleConfirm = () => {
    setStatusOffline(deliverymenIds, {
      onSuccess: () => {
        onClose();
        queryClient.invalidateQueries({ queryKey: [GET_INFOS_QUERY_KEY] });
        if (fnCallback) {
          fnCallback();
        }
      },
    });
  };

  return (
    <Modal
      isOpen={open}
      onClose={onClose}
      width={MODAL_WIDTH.md}
      title="Mudança de status entregador"
    >
      <div className={styles.container}>
        <h5>Atenção!</h5>
        <span>
          Tem certeza que deseja alterar o status do entregador para offline?
        </span>

        <div className={styles.containerButton}>
          <ButtonMain width="40%" secondary onClick={() => onClose()}>
            Cancelar
          </ButtonMain>

          <ButtonMain
            onClick={handleConfirm}
            width="40%"
            loading={isLoading}
            className={styles.buttonStyle}
            disabled={isLoading}
          >
            Sim, alterar o status
          </ButtonMain>
        </div>
      </div>
    </Modal>
  );
}

export { ModalSetStatusOfflineDeliveryman };
